import $ from 'jquery';
import './tabbed.scss';

/**
 * @class Tabbed
 * @description
 *		Creates tabs to switch between parts of differtent blocks
 *
 *
 * @usage
 *		place the data-component="Tabbed" on the
 *		containing element. Within this element there should be a title element
 *		in order to work.
 *
 *		- The block title : data-role="tabbed-title"
 *
 *		By default when in accordion state all tabs are closed (advisor wish)
 *		To enable deeplinking to accordion tabs set deeplinkacc to true
 *
 */


window.nn.registerModule('tabbed', function (element) {
  const tabbed = new Tabbed(element);
  tabbed.init();
  return tabbed;
});

nn.component = nn.component || {};
nn.component.Tabbed = window.app.tabbed.Index;

class Tabbed {
  constructor(element) {
    this.element = $(element);
  }
  getTabBaseId() {
    Tabbed.instanceCount = (Tabbed.instanceCount || 0) + 1;

    return this.elementId || 'tabbed-' + Tabbed.instanceCount;
  }
  getTabPanelId(index) {
    return this.tabBaseId + '-panel-' + index;
  }
  getTabTriggerId(index) {
    return this.tabBaseId + '-tab-' + index;
  }
  getAccordionTriggerId(index) {
    return this.tabBaseId + '-trigger-' + index;
  }
  getTabHeadersWidth() {
    let tabHeadersWidth = 0;

    this.tabHeaderItems.each(function () {
      tabHeadersWidth += $(this).outerWidth(true);
    });

    return tabHeadersWidth;
  }
  updatePanelFocusability() {
    this.tabPanels.each(function () {
      var panel = $(this);
      if (panel.hasClass('active') && panel.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').length === 0) {
        panel.attr('tabindex', '0');
      } else {
        panel.attr('tabindex', '-1');
      }
    });
  }
  activateTab(tabIndex) {
    if (this.tabNoStorage) {
      return this.toggleOrSelectTab(tabIndex);
    }

    if (!this.tabNoHash && window.history.replaceState) {
      window.history.replaceState({}, '', '#tab:' + this.elementId + '-' + tabIndex);
    } else if (this.tabNoHash && this.elementId) {
      nn.globals.storage.set('tabbed.' + this.elementId + '.index', tabIndex);
    }

    this.toggleOrSelectTab(tabIndex);
  }
  updatePanelLabelledBy(mode) {
    this.tabPanels.each($.proxy(function (index, tabPanelElement) {
      const tabPanel = $(tabPanelElement);
      const labelledBy = mode === 'accordion'
        ? this.getAccordionTriggerId(index)
        : this.getTabTriggerId(index);

      tabPanel.attr('aria-labelledby', labelledBy);
    }, this));
  }
  init() {
    this.elementId = this.element.find('> .uniqueid').text() || this.element.attr('id');
    this.tabBaseId = this.getTabBaseId();
    this.tabHeaderListAnchors = [];
    this.lastSelectedTab = null;
    this.tabPanels = this.element.find('div.tab');
    this.initialLoad = true;
    this.tabNoStorage = (this.element.attr('data-tabbed-nostorage') === "true");
    this.tabNoHash = (this.element.attr('data-tabbed-nohash') === "true");
    this.deeplinkAcc = (this.element.attr('data-tabbed-deeplinkacc') === "true");
    this.selectedTabIndex = this.element.attr('data-selected-tab-index');

    this.constructTabAccordeonHTML();
    this.bindEvents();
    this.viewportChangeHandler();

    if (this.selectedTabIndex) {
      this.selectTab(this.selectedTabIndex);
    }
  }
  constructTabAccordeonHTML() {

    this.tabPanels.prop('hidden', true);

    this.tabJustify = this.element.attr('data-justify');
    this.element.css('--tab-count', this.tabPanels.length);
    this.element.css('--tab-border-order', this.tabPanels.length + 1);
    this.element.css('--tab-panel-order', this.tabPanels.length + 2);
    this.tabPanels.each($.proxy(this.constructTab, this));

    if (this.tabJustify === 'distribute') {
      this.element.addClass('tabbed-component--items-' + this.tabPanels.length);
    }

    this.tabHeaderItems = this.element.find('> .tab-header-item');
    this.tablist = $('<div role="tablist"></div>');
    this.tabHeaderItems.first().before(this.tablist);
    this.tabHeaderItems.appendTo(this.tablist);
    this.tabHeaderListAnchors = this.tabHeaderItems.find('> a');

    $(window).trigger('tabbed:state:rendered', this.element);
  }
  bindEvents() {
    if (this.editMode) {
      $(window).one('resize', $.proxy(this.viewportChangeHandler, this));
    } else {
      this.element.on('click', '.tab-header-item > a', $.proxy(this.tabListClickHandler, this));
      this.element.on('click', '.tab-button', $.proxy(this.tabListClickHandler, this));
      this.element.on('keydown', '[role="tablist"] [role="tab"]', $.proxy(this.tabListKeydownHandler, this));
      $(window).on('hashchange', $.proxy(this.hashChangeHandler, this));
      $(window).on('resize', nn.helpers.debounce($.proxy(this.viewportChangeHandler, this), 500));
    }
  }
  viewportChangeHandler() {

    // iOS fires resize events upon toggling the address bar
    var bodyWidth = $('body').width();
    if (typeof this.lastBodyWidth !== 'undefined' && bodyWidth === this.lastBodyWidth) {
      return;
    }
    this.lastBodyWidth = bodyWidth;

    // in mobile always show accordion
    if ("mobile" === nn.settings.currentView) {
      this.toggleMode('accordion');
      return;
    }

    var tabElementWidth = this.element.width();
    var hadAccordionClass = this.element.hasClass('accordion');

    if (hadAccordionClass) {
      this.element.removeClass('accordion');
    }

    var tabListElementWidth = this.getTabHeadersWidth();

    if (hadAccordionClass) {
      this.element.addClass('accordion');
    }

    // if the tab-header is too wide, switch to accordion mode
    if (tabListElementWidth > tabElementWidth) {
      this.toggleMode('accordion');
    } else {
      this.toggleMode('tabs');
      if ("mobile" !== nn.settings.currentView) {
        this.toggleOrSelectTab(this.getDeeplinkTabIndexFromHash() || this.getDeeplinkTabIndexFromStorage());
      }
    }
  }
  constructTab(index, tabPanelElement) {

    var tabPanel = $(tabPanelElement),
      tabPanelTitle = tabPanel.find('> [data-role="tabbed-title"]:eq(0)');
    if (tabPanelTitle.length === 0) {
      // if there is no title do not render. Strange to have tab header link with no text
      return;
    }

    var tabHash = '#tab:' + this.elementId + '-' + index,
      tabPanelId = this.getTabPanelId(index),
      tabTriggerId = this.getTabTriggerId(index),
      accordionTriggerId = this.getAccordionTriggerId(index),
      tabHeaderTitle = tabPanelTitle.html(),
      tabHeaderItem = $('<div class="tab-header-item"></div>'),
      tabHeaderItemLink = $('<a href="' + tabHash + '" role="tab" id="' + tabTriggerId + '" data-tab-index="' + index + '" tabindex="-1" aria-selected="false" aria-controls="' + tabPanelId + '">' + tabHeaderTitle + '</a>'),
      tabButtonItem = $('<button type="button" class="tab-button" id="' + accordionTriggerId + '" data-tab-index="' + index + '" aria-expanded="false" aria-controls="' + tabPanelId + '">' + tabHeaderTitle + '</button>');


    tabHeaderItemLink.appendTo(tabHeaderItem);
    tabHeaderItem.css('--tab-order', index + 1);
    tabPanelTitle.addClass('tabbed-title');
    tabPanel.attr('data-tab-index', index);
    tabPanel.attr('id', tabPanelId);
    tabPanel.attr('role', 'tabpanel');
    tabPanel.attr('aria-labelledby', tabTriggerId);
    tabPanel.attr('aria-hidden', 'true');
    tabPanel.prop('hidden', true);
    tabPanel.attr('tabindex', '-1');
    tabHeaderItem.insertBefore(tabPanel);
    tabButtonItem.insertAfter(tabHeaderItem);
  }
  hashChangeHandler() {
    //ie triggers hashchange after replacestate. links in the same document to #tab wil not work
    if (window.location.hash.indexOf('#tab:') === -1) {
      this.toggleOrSelectTab(this.getDeeplinkTabIndexFromHash() || this.getDeeplinkTabIndexFromStorage());
    }
  }
  getDeeplinkTabIndexFromHash() {
    if (window.location.hash.indexOf('#tab:') !== -1) {
      // starts with index
      var deeplinkTabInfo = window.location.hash.replace('#tab:', '').split('-');
      var targetTab = deeplinkTabInfo.pop();
      var deeplinkId = deeplinkTabInfo.join('-');

      if (this.elementId === deeplinkId) {
        if (this.lastSelectedTab === null) {
          var self = this;
          setTimeout(function () {
            self.scrollToTab(targetTab);
          }, 500)
        }
        return parseInt(targetTab, 10);
      }
    } else if (window.location.hash.indexOf('#') !== -1) {
      // no #tab selected but perhaps there is link somewhere nested in an tab panel. Find it and return the index
      return this.getTabPanelByNestedLink();
    }

    //changed this for accordion state from 0 to null
    return null;
  }
  getDeeplinkTabIndexFromStorage() {
    var index = 0;

    if (!this.tabNoStorage && this.elementId && nn.globals.storage.get('tabbed.' + this.elementId + '.index') !== null) {
      index = nn.globals.storage.get('tabbed.' + this.elementId + '.index');
    }

    return index;
  }
  getTabPanelByNestedLink() {

    var possibleNestedAnchorHref = window.location.hash.replace('#', ''),
      tabToOpen = null;

    this.element.find('> .tab [id], a[name]').each(function (index, anchorElement) {
      var el = $(anchorElement);
      var attr = el.attr('id') || el.attr('name');
      if (attr === possibleNestedAnchorHref) {
        tabToOpen = el.closest('.tab');
      }
    });

    if (tabToOpen !== null) {
      return parseInt(tabToOpen.data('tab-index'), 10);
    }

    return 0;
  }
  scrollToTab(tabIndex) {
    var target_offset;
    var target_top;

    //get the top offset of the target accordion tab
    if (this.element.hasClass('accordion')) {
      target_offset = this.element.find('.tab-button:eq(' + tabIndex + ')').offset();
      target_top = target_offset.top - 15;
      //get the top offset of the target anchor
    } else {
      target_offset = this.element.offset();
      target_top = target_offset.top - 10;
    }
    $('html, body').animate({ scrollTop: target_top });

  }
  tabListClickHandler(event) {
    var clickedTabLink = $(event.currentTarget);
    var clickedTabIndex = parseInt(clickedTabLink.data('tab-index'), 10);

    if (this.tabNoStorage || this.tabNoHash) {
      event.preventDefault();
    }

    this.activateTab(clickedTabIndex);
  }
  tabListKeydownHandler(event) {
    const tabs = this.tablist.find('[role="tab"]');
    const currentIndex = tabs.index(event.currentTarget);
    let newIndex;

    switch (event.key) {
    case 'ArrowRight':
      newIndex = (currentIndex + 1) % tabs.length;
      break;
    case 'ArrowLeft':
      newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      break;
    case 'Home':
      newIndex = 0;
      break;
    case 'End':
      newIndex = tabs.length - 1;
      break;
    default:
      return;
    }

    event.preventDefault();
    var targetTab = $(tabs[newIndex]);
    targetTab.focus();
    this.activateTab(parseInt(targetTab.data('tab-index'), 10));
  }
  toggleOrSelectTab(clickedTabIndex, forceOpen) {

    if (this.element.hasClass('accordion')) {
      this.toggleTab(clickedTabIndex, forceOpen);
    } else {
      this.selectTab(clickedTabIndex);

    }
  }
  selectTab(tabIndex) {
    // header list
    this.tabHeaderItems.removeClass('active');
    this.tabHeaderListAnchors.each(function () {
      $(this).attr('aria-selected', 'false');
      $(this).attr('tabindex', '-1');
    });

    var tabHeaderListItem = this.tabHeaderListAnchors.filter('[data-tab-index="' + tabIndex + '"]');

    if (tabHeaderListItem.length === 0) {
      tabIndex = 0;
      tabHeaderListItem = this.tabHeaderListAnchors.filter('[data-tab-index="0"]');
    }

    if ("mobile" !== nn.settings.currentView) {
      tabHeaderListItem.parent().addClass('active');
      tabHeaderListItem.attr('aria-selected', 'true');
      tabHeaderListItem.attr('tabindex', '0');
    }

    // content panels
    this.tabPanels.each(function () {
      $(this).removeClass('active');
      $(this).attr('aria-hidden', 'true');
      $(this).prop('hidden', true);
    });

    if ("mobile" !== nn.settings.currentView) {
      this.tabPanels.filter('[data-tab-index="' + tabIndex + '"]').addClass('active').attr('aria-hidden', 'false').prop('hidden', false);
    }
    this.updatePanelFocusability();
    this.element.find('[data-render-role="child"]').trigger('RenderTree:Rerender');

    this.lastSelectedTab = tabIndex;

  }
  toggleTab(tabIndex, reset) {
    if (reset === true) {
      this.element.find('.tab-button').removeClass('active');
      this.element.find('.tab-button').attr('aria-expanded', 'false');
      this.tabPanels.removeClass('active');
      this.tabPanels.attr('aria-hidden', 'true');
      this.tabPanels.prop('hidden', true);
      this.updatePanelFocusability();
    }

    var selectedTabButton = this.element.find('.tab-button[data-tab-index="' + tabIndex + '"]');
    var selectedTabPanel = this.tabPanels.filter('[data-tab-index="' + tabIndex + '"]');

    if (selectedTabPanel.hasClass('active')) {
      selectedTabPanel.removeClass('active');
      selectedTabPanel.attr('aria-hidden', 'true');
      selectedTabPanel.prop('hidden', true);
      selectedTabButton.removeClass('active');
      selectedTabButton.attr('aria-expanded', 'false');
    } else {
      selectedTabPanel.addClass('active');
      selectedTabPanel.attr('aria-hidden', 'false');
      selectedTabPanel.prop('hidden', false);
      selectedTabButton.addClass('active');
      selectedTabButton.attr('aria-expanded', 'true');

      this.lastSelectedTab = tabIndex;

      this.element.find('[data-render-role="child"]').trigger('RenderTree:Rerender');
    }

    this.updatePanelFocusability();

  }
  toggleMode(mode) {
    if (mode === 'accordion' && !this.element.hasClass('accordion')) {
      this.element.addClass('accordion');
      // Hide desktop tab controls
      this.tabHeaderItems.find('> a').attr('aria-hidden', 'true').attr('tabindex', '-1');
      this.unselectAccordion();
      if (this.deeplinkAcc === true) {
        this.toggleOrSelectTab(this.getDeeplinkTabIndexFromHash());
      }
      this.updatePanelLabelledBy('accordion');
    } else if (mode === 'tabs') {
      if (this.element.hasClass('accordion')) {
        this.element.removeClass('accordion');
        // Show desktop tab controls
        this.tabHeaderItems.find('> a').attr('aria-hidden', 'false').removeAttr('tabindex');
        if (this.lastSelectedTab !== null) {
          this.toggleOrSelectTab(0, true);
        }
      }
      this.updatePanelLabelledBy('tabs');
    }
  }
  unselectAccordion() {
    // content panels
    this.element.find('.tab-button').removeClass('active');
    this.element.find('.tab-button').attr('aria-expanded', 'false');
    this.tabPanels.removeClass('active');
    this.tabPanels.attr('aria-hidden', 'true');
    this.tabPanels.prop('hidden', true);

    this.tabPanels.each(function () {
      $(this).removeClass('active');
    });

    this.element.find('[data-render-role="child"]').trigger('RenderTree:Rerender');
  }
}
